import { render, staticRenderFns } from "./OntologyCards.vue?vue&type=template&id=41307e62&"
import script from "./OntologyCards.vue?vue&type=script&lang=js&"
export * from "./OntologyCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports